// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preview__audio_content[data-v-7252b35a] {\n  height: 100%;\n  width: 100%;\n}\n.main_audio[data-v-7252b35a] {\n  height: 100%;\n  width: 100%;\n  max-width: 800px;\n  padding-top: 14%;\n}\n.audio_preview[data-v-7252b35a] {\n  width: 100%;\n  max-width: 650px;\n}\n* .container_plyr[data-v-7252b35a] {\n  --plyr-audio-controls-background: #f0f0f0;\n}", ""]);
// Exports
module.exports = exports;
